import type { Dispatch, SetStateAction } from 'react';
import type { ChatMessageItem } from '../../types';

export const EVENTS_RECONNECT_DELAY_MS = 3000;

/** 把一条独立消息按 id 去重后 append 到消息流；已存在则原样返回，不重复插入。 */
export const appendUniqueMessage = (
  setMessages: Dispatch<SetStateAction<ChatMessageItem[]>>,
  item: ChatMessageItem,
): void => {
  setMessages((prev) => (prev.some((m) => m.id === item.id) ? prev : [...prev, item]));
};

export const RESUMABLE_TYPES = new Set<string | undefined>([
  'conversation.thinking.started',
  'conversation.thinking.delta',
  'conversation.thinking.completed',
  'conversation.tool.started',
  'conversation.tool.completed',
  'conversation.message.delta',
  'conversation.message.created',
  'conversation.artifact.created',
]);

// 会被 handleDefaultEvent 的 switch 真正消费、且需要参与 turn 绑定的事件类型：
// RESUMABLE_TYPES（turn 仍在产出）加上两个收尾事件。其余类型（assistant.state.changed /
// turn.accepted / turn.started 等）不在此列——后端偶发会给它们带上"上一轮"的 turn_id 并抢在
// 本轮首个真实事件之前到达；若放行会在 turn 绑定处把 activeTurnIdRef 锁死到旧 turn，导致本轮
// 真正的 thinking/tool/message/turn.completed 全部命中 turn 不匹配守卫被丢弃 —— 表现为
// "思考中"永不收尾。
export const ACTIONABLE_TURN_EVENT_TYPES = new Set<string | undefined>([
  ...RESUMABLE_TYPES,
  'conversation.turn.completed',
  'conversation.turn.failed',
]);

export const isAssistantPlaceholder = (m: ChatMessageItem) =>
  m.role === 'assistant' && !m.content?.trim() && !m.story && !m.tool_calls?.length && !m.fileList?.length;
